// import React, { useState, useCallback, useEffect } from "react";
// import Form from "react-bootstrap/Form";
// import DataTable from "react-data-table-component";
// import { MENUITEMS } from "../../../Layout/Sidebar/Menu";
// import { Button, Card, CardHeader, FormGroup, Input, Label } from "reactstrap";
// import { Breadcrumbs, H6 } from "../../../AbstractElements";
// import {
//   CreateRolePermission,
//   DoctorDepartmentList,
//   ReadRole,
//   ReadRolePermission,
//   StaffCategoryList,
// } from "../../../apiController";
// import { toast } from "react-toastify";

// import { roles_permissions } from "../../../Layout/Sidebar/Menu";
// import { useForm, Controller } from "react-hook-form";

// const Permission = () => {
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [selectedRole, setSelectedRole] = useState("");
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [department, setDepartment] = useState([]);
//   const [staffCategory, setStaffCategory] = useState([]);
//   const [role, setRole] = useState([]);
//   const [permission, setPermission] = useState([]);
//   const [combinedPermissionList, setCombinedPermissionList] = useState([]);
  
//   const { control, handleSubmit, setValue } = useForm();

//   const userPermission = roles_permissions.find(
//     (role) => role.module_name === "User Permission"
//   );

//   const extractTitles = (items) => {
//     return items.flatMap((item) => {
//       if (item.children) {
//         return [item.title, ...extractTitles(item.children)];
//       } else {
//         return item.title;
//       }
//     });
//   };

//   const extraMenu = [
//     // Define extraMenu items as required
//   ];

//   const generatePermissionList = () => {
//     let globalIndex = 0;
//     const permissions = MENUITEMS.flatMap((feat) =>
//       feat.Items.flatMap((fea) => {
//         const titles = extractTitles([fea]);
//         return titles.map((title) => {
//           const featureId = fea.id;
//           const rowId = ++globalIndex;

//           return {
//             ind: rowId,
//             id: rowId,
//             features: title,
//             view: "view",
//             create: "create",
//             update: "update",
//             delete: "delete",
//           };
//         });
//       })
//     );

//     // Add permissions for extraMenu items
//     const extraPermissions = extraMenu.map((item) => {
//       const rowId = ++globalIndex;
//       return {
//         ind: rowId,
//         id: rowId,
//         features: item.title,
//         view: "view",
//         create: "create",
//         update: "update",
//         delete: "delete",
//       };
//     });

//     return [...permissions, ...extraPermissions];
//   };

//   const permissionList = generatePermissionList();

//   useEffect(() => {
//     setCombinedPermissionList(permissionList);
//   }, [permission]);

//   const handleRowSelected = useCallback((state) => {
//     setSelectedRows(state.selectedRows);
//   }, []);

//   const submitPermissions = (data) => {
//     const permissions = combinedPermissionList.map((row) => ({
//       module_id: row.id,
//       module_name: row.features,
//       view_access: data[`${row.id}_view`] || false,
//       create_access: data[`${row.id}_create`] || false,
//       edit_access: data[`${row.id}_edit`] || false,
//       delete_access: data[`${row.id}_delete`] || false,
//     }));

//     const payload = {
//       role_id: selectedRole,
//       category_id: selectedCategory,
//       permission: permissions,
//     };

//     storeRolePermission(payload);
//   };

//   const storeRolePermission = async (formData) => {
//     setIsSubmitting(true);
//     try {
//       const response = await CreateRolePermission(formData);
//       if (response.status === true) {
//         toast.success("Updated Successfully!", {
//           position: toast.POSITION.TOP_CENTER,
//         });
//       }
//     } catch (error) {
//       toast.error("An error occurred!", {
//         position: toast.POSITION.TOP_CENTER,
//       });
//     } finally {
//       setIsSubmitting(false);
//       setSelectedCategory("");
//       setSelectedRole("");
//     }
//   };

//   useEffect(() => {
//     // Fetch necessary data
//     fetchDoctorDepartment();
//     fetchStaffCategory();
//     fetchRole();
//   }, []);

//   const fetchDoctorDepartment = async () => {
//     const response = await DoctorDepartmentList();
//     if (response.status === true) {
//       setDepartment(response.data);
//     }
//   };

//   const fetchRole = async () => {
//     const response = await ReadRole();
//     if (response.status === true) {
//       setRole(response.data);
//     }
//   };

//   const fetchStaffCategory = async () => {
//     const response = await StaffCategoryList();
//     if (response.status === true) {
//       setStaffCategory(response.data);
//     }
//   };

//   const tableColumns = [
//     {
//       name: "#",
//       selector: (row) => row.ind,
//       sortable: true,
//       center: false,
//     },
//     {
//       name: "Features",
//       selector: (row) => row.features,
//       sortable: false,
//       center: false,
//     },
//     {
//       name: "View",
//       cell: (row) => (
//         <Controller
//           name={`${row.id}_view`}
//           control={control}
//           render={({ field }) => (
//             <Input
//               type="checkbox"
//               {...field}
//               checked={field.value || false}
//             />
//           )}
//         />
//       ),
//       sortable: false,
//       center: true,
//     },
//     {
//       name: "Create",
//       cell: (row) => (
//         <Controller
//           name={`${row.id}_create`}
//           control={control}
//           render={({ field }) => (
//             <Input
//               type="checkbox"
//               {...field}
//               checked={field.value || false}
//             />
//           )}
//         />
//       ),
//       sortable: false,
//       center: true,
//     },
//     {
//       name: "Update",
//       cell: (row) => (
//         <Controller
//           name={`${row.id}_edit`}
//           control={control}
//           render={({ field }) => (
//             <Input
//               type="checkbox"
//               {...field}
//               checked={field.value || false}
//             />
//           )}
//         />
//       ),
//       sortable: false,
//       center: true,
//     },
//     {
//       name: "Delete",
//       cell: (row) => (
//         <Controller
//           name={`${row.id}_delete`}
//           control={control}
//           render={({ field }) => (
//             <Input
//               type="checkbox"
//               {...field}
//               checked={field.value || false}
//             />
//           )}
//         />
//       ),
//       sortable: false,
//       center: true,
//     },
//   ];

//   const options = role.map((role) => ({
//     id: role.id,
//     name: role.role_name,
//   }));

//   return (
//     <Card>
//       <Breadcrumbs
//         mainTitle="Roles and Permission"
//         parent="Dashboard"
//         title="rolesandpermission"
//       />
//       <CardHeader>
//         <FormGroup>
//           <Label>
//             {" "}
//             <h6> Role</h6>
//           </Label>
//           <Input
//             type="select"
//             name="role"
//             id="userrole"
//             value={selectedRole}
//             onChange={(e) => setSelectedRole(e.target.value)}
//           >
//             <option value="">Select Role Type</option>
//             {options.map((option) => (
//               <option key={option.id} value={option.id}>
//                 {option.name}
//               </option>
//             ))}
//           </Input>
//         </FormGroup>
//       </CardHeader>

//       {selectedRole && ![1, 4, 5].includes(Number(selectedRole)) && (
//         <FormGroup>
//           <Label>
//             <h6>Category</h6>
//           </Label>
//           <Input
//             type="select"
//             name="category"
//             id="usercategory"
//             value={selectedCategory}
//             onChange={(e) => setSelectedCategory(e.target.value)}
//           >
//             <option value="">Select Category</option>
//             {(selectedRole === "2" ? department : staffCategory).map(
//               (option) => (
//                 <option key={option.id} value={option.id}>
//                   {option.title || option.name}
//                 </option>
//               )
//             )}
//           </Input>
//         </FormGroup>
//       )}

//       <DataTable
//         data={combinedPermissionList}
//         columns={tableColumns}
//         striped={true}
//         pagination
//         fixedHeader
//         title={"Permission"}
//       />

//       {selectedRole.length !== 0 &&
//       (userPermission?.create_access || userPermission?.edit_access) ? (
//         <Button
//           color="primary"
//           onClick={handleSubmit(submitPermissions)}
//           disabled={isSubmitting}
//         >
//           {isSubmitting ? "Submitting..." : "Submit Permissions"}
//         </Button>
//       ) : null}
//     </Card>
//   );
// };

// export default Permission;
import React, { useState, useCallback, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  FormGroup,
  Input,
  Label,
  Table,
} from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { toast } from "react-toastify";
import { Controller, useForm } from "react-hook-form";
import {
  CreateRolePermission,
  DoctorDepartmentList,
  ReadRole,
  StaffCategoryList,
  ReadRolePermission
} from "../../../apiController";
import { MENUITEMS } from "../../../Layout/Sidebar/Menu";
import { roles_permissions } from "../../../Layout/Sidebar/Menu";

const Permission = () => {
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [department, setDepartment] = useState([]);
  const [staffCategory, setStaffCategory] = useState([]);
  const [role, setRole] = useState([]);
  const [combinedPermissionList, setCombinedPermissionList] = useState([]);
  const [permission, setPermission] = useState([]);
  const { control, handleSubmit, reset } = useForm();

  const userPermission = roles_permissions.find(
    (role) => role.module_name === "User Permission"
  );

  const extractTitles = (items) => {
    return items.flatMap((item) => {
      if (item.children) {
        return [item.title, ...extractTitles(item.children)];
      } else {
        return item.title;
      }
    });
  };
  const extraMenu = [
    {
      title: "Patient Clinic Income",
    },
    {
      title: "Pharmacy Income",
    },
    {
      title: "Net Profit",
    },
    {
      title: "Pharmacy Expense",
    },
    {
      title: "Consultant Expense",
    },
    {
      title: "Lab Payment",
    },
    {
      title: "Other",
    },
    {
      title: "Salary",
    },
    {
      title: "Inventory Expense",
    },
    {
      title: "PD Diagnosis",
    },
    {
      title: "PD Treatment Plan ",
    },
    {
      title: "PD Summary",
    },
    {
      title: "PD Medical Report",
    },
    {
      title: "PD Prescription",
    },
    {
      title: "PD Payment",
    },
  ];
  const generatePermissionList = () => {
    let globalIndex = 0;
    
    // Extract permissions from MENUITEMS
    const permissions = MENUITEMS.flatMap((feat) =>
      feat.Items.flatMap((fea) => {
        const titles = extractTitles([fea]);
        return titles.map((title) => {
          const rowId = ++globalIndex;
  
          return {
            ind: rowId,
            id: rowId,
            features: title,
            view: "view",
            create: "create",
            update: "update",
            delete: "delete",
          };
        });
      })
    );
  
    // Append extraMenu items to the permissions list
    const extraPermissions = extraMenu.map((item) => {
      const rowId = ++globalIndex;
      return {
        ind: rowId,
        id: rowId,
        features: item.title,
        view: "view",
        create: "create",
        update: "update",
        delete: "delete",
      };
    });
  
    return [...permissions, ...extraPermissions];
  };
  

  const permissionList = generatePermissionList();

  useEffect(() => {
    setCombinedPermissionList(permissionList);
  }, []);

  useEffect(() => {
    // Sync the form with existing role permissions (roles_permissions)
    const defaultValues = {};
    permission.forEach((perm) => {
      defaultValues[`${perm.module_id}_view`] = perm.view_access;
      defaultValues[`${perm.module_id}_create`] = perm.create_access;
      defaultValues[`${perm.module_id}_edit`] = perm.edit_access;
      defaultValues[`${perm.module_id}_delete`] = perm.delete_access;
    });
    reset(defaultValues); // Pre-fill the form with default values from roles_permissions
  }, [reset, permission]);


  const submitPermissions = (data) => {
    
    const permissions = combinedPermissionList.map((row) => ({
      module_id: row.id,
      module_name: row.features,
      view_access: data[`${row.id}_view`] || false,
      create_access: data[`${row.id}_create`] || false,
      edit_access: data[`${row.id}_edit`] || false,
      delete_access: data[`${row.id}_delete`] || false,
    }));

    const payload = {
      role_id: selectedRole,
      category_id: selectedCategory,
      permission: permissions,
    };

    console.warn(payload)

    storeRolePermission(payload);
  };

  const storeRolePermission = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await CreateRolePermission(formData);
      if (response.status === true) {
        toast.success("Updated Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setIsSubmitting(false);
      setSelectedCategory("");
      setSelectedRole("");
    }
  };

  useEffect(() => {
    fetchDoctorDepartment();
    fetchStaffCategory();
    fetchRole();

    if (["1", "4", "5"].includes(selectedRole)) {
      viewRolePermission({
        role_id: selectedRole,
      });
    } else if (["2", "3"].includes(selectedRole) && selectedCategory) {
      viewRolePermission({
        role_id: selectedRole,
        category_id: selectedCategory,
      });
    }
  }, [selectedRole,selectedCategory]);

  const fetchDoctorDepartment = async () => {
    const response = await DoctorDepartmentList();
    if (response.status === true) {
      setDepartment(response.data);
    }
  };

  const fetchRole = async () => {
    const response = await ReadRole();
    if (response.status === true) {
      setRole(response.data);
    }
  };

  const fetchStaffCategory = async () => {
    const response = await StaffCategoryList();
    if (response.status === true) {
      setStaffCategory(response.data);
    }
  };

  const viewRolePermission = async (formData) => {
    try {
      const response = await ReadRolePermission(formData);
      if (response.status === true) {
        const viewData = response.data;
        setPermission(viewData.permissions);
        console.log(viewData.permissions);
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const options = role.map((role) => ({
    id: role.id,
    name: role.role_name,
  }));


  return (
    <Card>
      <Breadcrumbs
        mainTitle="Roles and Permission"
        parent="Dashboard"
        title="rolesandpermission"
      />
      <CardHeader>
        <FormGroup>
          <Label>
            <h6>Role</h6>
          </Label>
          <Input
            type="select"
            name="role"
            id="userrole"
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value)}
          >
            <option value="">Select Role Type</option>
            {options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </Input>
        </FormGroup>
        {selectedRole && ![1, 4, 5].includes(Number(selectedRole)) && (
        <FormGroup>
          <Label>
            <h6>Category</h6>
          </Label>
          <Input
            type="select"
            name="category"
            id="usercategory"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="">Select Category</option>
            {(selectedRole === "2" ? department : staffCategory).map(
              (option) => (
                <option key={option.id} value={option.id}>
                  {option.title || option.name}
                </option>
              )
            )}
          </Input>
        </FormGroup>
      )}
      </CardHeader>

      

      <Table bordered>
        <thead>
          <tr>
            <th>Features</th>
            <th>Permissions</th>
          </tr>
        </thead>
        <tbody>
          {combinedPermissionList.map((row) => (
            <tr key={row.id}>
              <td>{row.features}</td>
              <td>
                <FormGroup check inline>
                  <Label check>
                    <Controller
                      name={`${row.id}_view`}
                      control={control}
                      render={({ field }) => (
                        <Input
                         className="checkbox_animated"
                          type="checkbox"
                          {...field}
                          checked={field.value || false}
                        />
                      )}
                    />{" "}
                    View
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Controller
                      name={`${row.id}_create`}
                      control={control}
                      render={({ field }) => (
                        <Input
                         className="checkbox_animated"
                          type="checkbox"
                          {...field}
                          checked={field.value || false}
                        />
                      )}
                    />{" "}
                    Create
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Controller
                      name={`${row.id}_edit`}
                      control={control}
                      render={({ field }) => (
                        <Input
                         className="checkbox_animated"
                          type="checkbox"
                          {...field}
                          checked={field.value || false}
                        />
                      )}
                    />{" "}
                    Update
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Controller
                      name={`${row.id}_delete`}
                      control={control}
                      render={({ field }) => (
                        <Input
                         className="checkbox_animated"
                          type="checkbox"
                          {...field}
                          checked={field.value || false}
                        />
                      )}
                    />{" "}
                    Delete
                  </Label>
                </FormGroup>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {selectedRole.length !== 0 &&
      (userPermission?.create_access || userPermission?.edit_access) ? (
        <Button
          color="primary"
          onClick={handleSubmit(submitPermissions)}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit Permissions"}
        </Button>
      ) : null}
    </Card>
  );
};

export default Permission;
